
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
// import { getChargeCardDetail, getOpenCard } from "@/api/api-non-name";
// import regular from "@/common/regular";
// import validate from "@/common/regular";
import piSelectOper from "@/components/select-oper/select-oper.vue";
import { getOptionList, optionKey } from "@/api/api-dict";

import { getMerchantInfo } from "@/api/api-operation-service";
import { getDrawcashSave, getDrawcashDetail } from "@/api/api-order-service";
import i18n from "@/config/i18n";
@Component({
  components: {
    piSelectOper
  }
})
export default class PiHairpinManage extends Vue {
  private availableAmount = 0;
  private minWithdrawAmount = 0;
  private isAdd = true;
  private FormData: objAny = {};
  private ruleInline = {
    cardPkId: [],
    cardSerialNumber: [],
    phoneNo: [
      // {
      //   required: false,
      //   validator: validate.tel,
      //   trigger: "blur"
      // }
    ],
    totalAmount: [
      {
        required: true,
        trigger: "blur",
        validator: this.totalAmountRule
      }
    ]
  };
  private invoiceTypeList: objAny[] = [];
  isShowMessage = false;

  isError = true;
  private formInline: objAny = {
    bankAccountName: "",
    bankAccountNo: "",
    bankDeposit: "",
    invoiceType: 0,
    serviceCharges: "",
    totalAmount: "",
    transferAmount: ""
  };

  private rules: objAny[] = [];

  public totalAmountRule(rule: objAny, value: string) {
    const reg = /^(\d+|\d+\.\d{1,4})$/;
    if (!value) {
      return new Error(i18n.t("withdrawFormAdd.amountNullPl") + "");
    } else if (!reg.test(value)) {
      return new Error(i18n.t("withdrawFormAdd.amountErrorPl") + "");
    }
    //  else if (Number(value) > 5000) {
    //   return new Error("一次性提现金额不能多于5000元");
    // }
    else if (Number(value) < this.minWithdrawAmount) {
      const text: string =
        i18n.t("withdrawFormAdd.amountMin") + "" + this.minWithdrawAmount;
      return new Error(text);
    } else if (Number(value) > this.availableAmount) {
      return new Error(i18n.t("withdrawFormAdd.amountMax") + "");
    }
    return true;
  }
  public handAddSubmit() {
    this.FormData.validate((valid: boolean) => {
      if (valid) {
        this.addDrawcash();
      } else {
        this.$nextTick(() => {
          console.log("error");
        });
      }
    });
  }
  public handSeeFirst() {
    if (!this.formInline.totalAmount) {
      this.$Message.error(i18n.t("withdrawFormAdd.amountNullPl") + "");
    } else {
      this["$common"].save("withdraw-form-addItem", this.formInline); // 存在本地
      this["$router"].push("/revenue-settlement/withdraw-form/cash-template");
    }
  }
  public handAddCancel() {
    this["$router"].push("/revenue-settlement/withdraw-form");
  }
  public handleTotalAmount() {
    if (this.formInline.totalAmount > this.availableAmount) {
      // this.$Message.error("提现金额不能超过可提现金额");
      return;
    }
    if (this.formInline.totalAmount) {
      if (
        this.rules[0] &&
        this.formInline.totalAmount < this.rules[0].fromValue
      ) {
        this.formInline.serviceCharges = 0;
        this.formInline.transferAmount = this.formInline.totalAmount;
      } else {
        this.rules.map((item: objAny) => {
          if (
            (this.formInline.totalAmount >= item.fromValue &&
              this.formInline.totalAmount <= item.toValue) ||
            (this.formInline.totalAmount >= item.fromValue &&
              item.toValue == null)
          ) {
            this.formInline.serviceCharges = (
              this.formInline.totalAmount *
              (item.fee / 100)
            ).toFixed(2);
            this.formInline.transferAmount = (
              this.formInline.totalAmount - this.formInline.serviceCharges
            ).toFixed(2);
          }
        });
      }
    }
  }
  public handDrawAll() {
    this.formInline.totalAmount = this.availableAmount;
    this.handleTotalAmount();
  }
  /**
   * 监听新增提现单
   */
  async addDrawcash() {
    const ret = await getDrawcashSave(this.formInline);
    if (ret.status === this.$config.apiStatus) {
      if (this.isAdd) {
        this.$Message.success(i18n.t("operationSucess"));
      } else {
        this.$Message.success(i18n.t("operationSucess"));
      }
      this["$router"].push("/revenue-settlement/withdraw-form");
    }
  }
  // 获取商户信息
  async getMerchantInfo() {
    const ret = await getMerchantInfo({});
    if (ret.status == this["$config"].apiStatus) {
      this.formInline.fullName = ret.data[0].fullName;
      this.formInline.bankAccountName = ret.data[0].bankAccountName;
      this.formInline.bankAccountNo = ret.data[0].bankAccountNo;
      this.formInline.bankDeposit = ret.data[0].bankDeposit;
    }
  }
  async getTypeList() {
    const ret = await getOptionList([optionKey.invoiceTypeList]); //请求字典
    this.invoiceTypeList = ret[optionKey.invoiceTypeList]; // 发票类型
  }
  async getDrawcashDetail() {
    const ret = await getDrawcashDetail({});
    if (ret.status == this["$config"].apiStatus) {
      this.availableAmount = ret.data[0].availableAmount;
      const rules = ret.data[0].drawCashChargeRule.rules;
      this.minWithdrawAmount = ret.data[0].minWithdrawAmount;
      this.rules = rules;
      if (this.formInline.totalAmount > 0) {
        this.handleTotalAmount();
      }
    }
  }
  mounted() {
    if (!this.FormData.$el) {
      this.$nextTick((): void => {
        this.FormData = this.$refs["formInline"];
      });
    }
    const item = this["$common"].get("withdraw-form-item");
    if (item) {
      this.isAdd = false;
      this.formInline.totalAmount = item.totalAmount;
      this.formInline.orderNo = item.orderNo;
    } else {
      this.isAdd = true;
    }
    this.getMerchantInfo();
    this.getTypeList();
    this.getDrawcashDetail();
  }
}
